import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { supabase } from './supabaseClient';

// @mui material components
import Grid from "@mui/material/Grid";
import { Card, CircularProgress, IconButton, } from '@mui/material';

// @mui icons
import AddCircleIcon from '@mui/icons-material/AddCircle';

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from 'components/MDAvatar';

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataNotFound from 'components/NoData/dataNotFound';
import axios from 'axios';
import MDButton from 'components/MDButton';
import DeleteDialog from 'components/DeleteDialogBox/deleteDialog';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { UserDataContext } from 'context';
import TailwindLayout from 'TailwindcssComponents/TailwindLayout';
import TopBar from 'TailwindcssComponents/TopBar';
import FooterTailwind from 'TailwindcssComponents/Footer';

export default function SingleVenue() {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const bearerToken = localStorage.getItem('token');
  const { userData, selectedOrganization } = useContext(UserDataContext);
  const userRole = userData?.isAdmin ? 'admin' : selectedOrganization?.name || 'user';
  const [venueData, setVenueData] = useState([]);
  const [zoneData, setZoneData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [openDeleteDialogBox, setOpenDeleteDialogBox] = useState();
  const navigate = useNavigate();
  const openPage = (route) => {
    navigate(route);
  };
  const { id } = useParams();

  const fetchVenue = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${apiUrl}event-service/event-venue/${id}`);
      if (response.data?.success) {
        setVenueData(response.data?.data);
      } else throw new Error(response.data?.message || 'Error in fetching venues');
    } catch (error) {
      console.error(error.response?.data?.message || error.message);
    } finally {
      setIsLoading(false);
    }
  };

  // const fetchZoneData = async () => {
  //   try {
  //     setIsLoading(true);
  //       const response = await axios.get(`${apiUrl}event-service/event-venue/${id}`);
  //       if (response.data?.success) {
  //           setVenueData(response.data?.data);
  //           console.log(response.data.data)
  //       } else throw new Error(response.data?.message || 'Error in fetching venues');
  //   } catch (error) {
  //       console.error(error.response?.data?.message || error.message);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  useEffect(() => {
    fetchVenue();
  }, [id])

  // model for delete confirmation
  const handleDelete = async () => {
    setOpenDeleteDialogBox(true);
  };

  const closeDeleteDialogBox = () => {
    setOpenDeleteDialogBox(false);
  };

  const handleDeleteConfirm = async () => {
    try {
      const response = await axios.delete(`${apiUrl}event-service/event-venue/${id}`,
        {
          headers: { 'Authorization': `Bearer ${bearerToken}` }
        });
      if (response?.data.success) {
        toast.warning(response?.data.message || 'Venue has been deleted');
        setTimeout(() => {
          navigate(-1);
        }, 1000);
      }
      else throw new Error(response?.data.message || 'Unable to delete');
    } catch (error) {
      console.error(error.response?.data.message || error.message);
      toast.error(error.response?.data.message || error.message);
    } finally {
      setOpenDeleteDialogBox(false);
    };
  };

  return (
    <TailwindLayout>
      <TopBar />
      <div className='p-6'>
        {isLoading ?
          <MDBox p={3} display="flex" justifyContent="center">
            <CircularProgress color="info" />
          </MDBox>
          :
          <MDBox position="relative" mb={5}>
            {/* <MDBox
            display="flex"
            alignItems="center"
            position="relative"
            minHeight="18.75rem"
            borderRadius="xl"
            sx={{
              backgroundImage: ({ functions: { rgba, linearGradient }, palette: { gradients } }) =>
                `${linearGradient(
                  rgba(gradients.info.main, 0.6),
                  rgba(gradients.info.state, 0.6)
                )}, url(${venueData[0]?.coverImage || ''})`,
              backgroundSize: "cover",
              backgroundPosition: "50%",
              overflow: "hidden",
            }}
          /> */}

            {venueData ?
              <>
                <Card
                  sx={{
                    position: "relative",
                    py: 2,
                    px: 2,
                  }}
                >
                  <Grid container spacing={3} alignItems="flex-start">
                    {/* <Grid item>
      <MDAvatar src={venueData[0].theatreImage} alt="profile-image" size="lg" shadow="sm" />
    </Grid> */}
                    <Grid item xs={12} container direction="column" justifyContent="space-between" sx={{ height: "100%" }}>
                      <MDBox>
                        <MDTypography variant="h5" fontWeight="medium">
                          {venueData.name}
                        </MDTypography>
                        <MDTypography variant="button" color="text" fontWeight="regular">
                          {venueData.city}
                        </MDTypography>
                      </MDBox>
                      {/* delete button */}
                      {/* <MDBox display="flex" justifyContent="flex-end" mt="auto">
                      <MDButton
                        onClick={() => handleDelete()}
                        disabled={venueData.zones.length > 0}
                        variant="text"
                        size="medium"
                        color="warning"
                      >
                        Delete
                      </MDButton>
                    </MDBox> */}
                    </Grid>
                  </Grid>
                </Card>
                <MDBox mt={5} mb={3}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6} xl={4}>
                      <Card sx={{ boxShadow: "none" }}>
                        <MDBox p={2}>
                          <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                            Venue Information
                          </MDTypography>
                        </MDBox>
                        <MDBox pt={1} pb={2} px={2} lineHeight={1.25}>
                          <MDTypography variant="caption" fontWeight="bold" color="text" textTransform="uppercase">
                            Name
                          </MDTypography>
                          <MDBox display="flex" alignItems="center" mb={0.5}>
                            <MDBox width="80%" ml={0.5}>
                              <MDTypography variant="button" fontWeight="regular" color="text">
                                {venueData.name}
                              </MDTypography>
                            </MDBox>
                          </MDBox>
                        </MDBox>
                        <MDBox pt={1} pb={2} px={2} lineHeight={1.25}>
                          <MDTypography variant="caption" fontWeight="bold" color="text" textTransform="uppercase">
                            Address
                          </MDTypography>
                          <MDBox display="flex" alignItems="center" mb={0.5}>
                            <MDBox width="80%" ml={0.5}>
                              <MDTypography variant="button" fontWeight="regular" color="text">
                                {venueData.city || venueData.venueCity.name}
                              </MDTypography>
                            </MDBox>
                          </MDBox>
                        </MDBox>
                        <MDBox pt={1} pb={2} px={2} lineHeight={1.25}>
                          <MDTypography variant="caption" fontWeight="bold" color="text" textTransform="uppercase">
                            Telephone
                          </MDTypography>
                        </MDBox>
                      </Card>
                    </Grid>
                    <Grid item xs={12} md={6} xl={4}>
                      <Card sx={{ boxShadow: "none" }}>
                        <MDBox p={2}>
                          <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                            Owner&apos;s Information
                          </MDTypography>
                        </MDBox>
                        <MDBox pt={1} pb={2} px={2} lineHeight={1.25}>
                          <MDTypography variant="caption" fontWeight="bold" color="text" textTransform="uppercase">
                            Name
                          </MDTypography>
                          <MDBox display="flex" alignItems="center" mb={0.5}>
                            <MDBox width="80%" ml={0.5}>
                              <MDTypography variant="button" fontWeight="regular" color="text">
                                {venueData.ownerName}
                              </MDTypography>
                            </MDBox>
                          </MDBox>
                        </MDBox>
                        <MDBox pt={1} pb={2} px={2} lineHeight={1.25}>
                          <MDTypography variant="caption" fontWeight="bold" color="text" textTransform="uppercase">
                            Mobile
                          </MDTypography>
                          <MDBox display="flex" alignItems="center" mb={0.5}>
                            <MDBox width="80%" ml={0.5}>
                              <MDTypography variant="button" fontWeight="regular" color="text">
                                {venueData.ownerMobile}
                              </MDTypography>
                            </MDBox>
                          </MDBox>
                        </MDBox>
                        <MDBox pt={1} pb={2} px={2} lineHeight={1.25}>
                          <MDTypography variant="caption" fontWeight="bold" color="text" textTransform="uppercase">
                            Mail
                          </MDTypography>
                          <MDBox display="flex" alignItems="center" mb={0.5}>
                            <MDBox width="80%" ml={0.5}>
                              <MDTypography variant="button" fontWeight="regular" color="text">
                                {venueData.ownerEmail}
                              </MDTypography>
                            </MDBox>
                          </MDBox>
                        </MDBox>
                      </Card>
                    </Grid>
                  </Grid>
                </MDBox>
              </>
              :
              <DataNotFound message={'Theatre Not Found !'} />
            }

            {/* zones */}
            {/* {venueData[0].isSeat && */}
            <>
              <MDBox mt={5} pt={3} px={2} lineHeight={1.25}>
                <MDTypography variant="h6" fontWeight="medium">
                  Zones
                </MDTypography>
                <MDBox mb={1}>
                  <MDTypography variant="button" color="text">
                    Customize your zones
                  </MDTypography>
                </MDBox>
              </MDBox>
              <MDBox p={2} mt={1}>
                <Grid container spacing={6}>
                  <Grid item xs={12} >
                    <Card
                      sx={{
                        backgroundColor: '#b8c7e0',
                        padding: '20px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '30px',
                      }}
                    >
                      <MDTypography>Stage This Way !</MDTypography>
                    </Card>
                  </Grid>
                  {venueData.zones.map((zone, index) => (
                    <Grid key={index} item xs={12}>
                      <Card
                        sx={{
                          backgroundColor: '#cfe0fd',
                          padding: '20px',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'center',
                          height: '150px'
                        }}
                        onClick={() => openPage(`/venues/single-venue/single-zone/${zone.id}`)} style={{ cursor: 'pointer' }}
                      >
                        <MDTypography>{zone.name}</MDTypography>
                      </Card>
                    </Grid>
                  ))}
                  {/* add zones */}
                  <Grid item xs={12}>
                    {userRole === 'admin' && (
                      <Card
                        sx={{
                          backgroundColor: '#cfe0fd',
                          padding: '20px',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'center',
                          height: '150px'
                        }}>
                        <IconButton disabled={userRole !== 'admin'} onClick={() => openPage(`/venues/single-venue/add-zone/${id}?isSeatLayout=${venueData.isSeat}`)}>
                          <AddCircleIcon color='info' sx={{ fontSize: 48 }} />
                        </IconButton>
                        <MDTypography>Add New Zone</MDTypography>
                      </Card>
                    )}
                  </Grid>
                </Grid>
              </MDBox>
            </>
            {/* } */}
          </MDBox>
        }
      </div>
      <FooterTailwind />
      <DeleteDialog
        open={openDeleteDialogBox}
        onClose={closeDeleteDialogBox}
        onDelete={handleDeleteConfirm}
        name={'venue'}
      />
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </TailwindLayout>
  )
}